import React from "react";
import styled from "styled-components";
import Timer from "../../../../components/common/timer";
import { CartIcon } from "../../../../components/svgs";

const SpeedShoppingTimer = ({
  history,
  timeRemaining,
  quantity,
  background,
  hideCart,
}) => (
  <Timer
    background={background}
    timeRemaining={timeRemaining}
    rightComponent={
      hideCart ? null : (
        <CartBadge
          onClick={() => history.push("/speedshopping/cart")}
          quantity={quantity}
          background={background}
        />
      )
    }
  />
);

const CartBadge = ({ background, quantity, onClick }) => (
  <BadgeWrapper onClick={onClick}>
    <BadgeIndicator background={background}>{quantity}</BadgeIndicator>
    <CartIcon width={25} fill={"white"} />
  </BadgeWrapper>
);

const BadgeWrapper = styled.div`
  position: relative;
`;

const BadgeIndicator = styled.div`
  position: absolute;
  padding: 2px 4px;
  font-size: 8px;
  border: 2px solid #fff;
  border-radius: 10px;
  background: ${(prop) => prop.background};
  top: -6px;
  right: -5px;
`;

export default SpeedShoppingTimer;
